<template>
  <div class="bg-brand-taupe-500">
    <PageHeader :headingContent="headingContent" />
    <div class="pb-20 px-4">
      <template v-if="show">
        <div class="container mx-auto mb-4 rounded-md bg-brand-taupe-100 p-6">
          <div class="gap-4">
            <p class="mb-4">
              If you would like further support from a dedicated AXA Business Resilience Manager, or if you need
              technical support with completing your questionnaire or logging in, please complete the form below and
              we’ll be happy to help.
            </p>
          </div>
          <form class="flex flex-wrap gap-4" @submit.prevent autocomplete="off">
            <div class="flex flex-wrap items-center w-full">
              <div class="w-1/4">
                <label for="name" class="font-semibold text-brand-blue-400">Name</label>
              </div>
              <div class="w-3/4">
                <input class="w-full border-gray-300 px-2 py-1 bg-white-100 border-2" id="name" type="text"
                  v-model="form.name" autocomplete="off"/>
              </div>
              <div v-if="$attrs.errors.name"
                class="border-2 border-red-500 bg-red-300 w-full px-2 py-1 text-gray-900 text-sm">
                {{ $attrs.errors.name }}
              </div>
            </div>
            <div class="flex flex-wrap items-center w-full">
              <div class="w-1/4">
                <label for="company" class="font-semibold text-brand-blue-400">Company</label>
              </div>
              <div class="w-3/4">
                <input class="w-full border-gray-300 px-2 py-1 bg-white-100 border-2" id="company" type="text"
                  v-model="form.company" autocomplete="off"/>
              </div>
              <div v-if="$attrs.errors.company"
                class="border-2 border-red-500 bg-red-300 w-full px-2 py-1 text-gray-900 text-sm">
                {{ $attrs.errors.company }}
              </div>
            </div>
            <div class="flex flex-wrap items-center w-full">
              <div class="w-1/4">
                <label for="email" class="font-semibold text-brand-blue-400">Email</label>
              </div>
              <div class="w-3/4">
                <input class="w-full border-gray-300 px-2 py-1 bg-white-100 border-2" id="email" type="email"
                  v-model="form.email" autocomplete="off"/>
              </div>
              <div v-if="$attrs.errors.email"
                class="border-2 border-red-500 bg-red-300 w-full px-2 py-1 text-gray-900 text-sm">
                {{ $attrs.errors.email }}
              </div>
            </div>
            <div class="flex flex-wrap items-center w-full">
              <div class="w-1/4">
                <label for="email" class="font-semibold text-brand-blue-400">Help needed</label>
              </div>
              <div class="w-3/4">
                <select v-model="form.type"
                  class="form-select w-full border-gray-300 bg-white-100 border-2 p-4 px-4 py-2">
                  <option value="General Assistance" class="px-4 py-2">
                    Risk Management Assistance
                  </option>
                  <option value="Technical Support" class="px-4 py-2">
                    Technical Website Support
                  </option>
                </select>
              </div>
              <div v-if="$attrs.errors.type"
                class="border-2 border-red-500 bg-red-300 w-full px-2 py-1 text-gray-900 text-sm">
                {{ $attrs.errors.email }}
              </div>
            </div>
            <div class="flex flex-wrap items-center w-full">
              <div class="w-1/4">
                <label for="question" class="font-semibold text-brand-blue-400">Your Question</label>
              </div>
              <div class="w-3/4">
                <textarea class="w-full border-gray-300 px-2 py-1 bg-white-100 border-2" id="question" rows="4"
                  v-model="form.question"></textarea>
              </div>
              <div v-if="$attrs.errors.question"
                class="border-2 border-red-500 bg-red-300 w-full px-2 py-1 text-gray-900 text-sm">
                {{ $attrs.errors.question }}
              </div>
            </div>
            <div class="flex items-center justify-end w-full">
              <button
                class="bg-brand-green-400 hover:bg-brand-green-200 text-white font-bold py-2 px-4 rounded justify-right uppercase"
                @click="
                  form.post('/contact', {
                    preserveScroll: true,
                    preserveState: true,
                    onSuccess: () => {
                      form.reset();
                    },
                  })
                ">
                Contact Us
              </button>
            </div>
          </form>
        </div>
      </template>
      <template v-else class="">
        <div class="container mx-auto mb-4 rounded-md bg-green-100 p-6">
          Thank you for contacting us. We will be in touch shortly.
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import PageHeader from "../Shared/PageHeader";
import StartReviewButton from "../Shared/StartReviewButton.vue";
import { ref } from "vue";
import { useForm } from "@inertiajs/inertia-vue3";

export default {
  data() {
    return {
      form: useForm({
        company: "",
        email: "",
        name: "",
        question: "",
        type: "General Assistance",
      }),
      headingContent: {
        hero: {
          image:
            "images/169362192_hands_hero.jpg",
          title: "Fleet Risk Review",
          subtitle: "In association with AXA Insurance",
        },
        page: {
          title: "Need Help?",
          subtitle: "",
        },
      },
    };
  },
  components: {
    PageHeader,
    StartReviewButton,
  },
  props: {
    show: {
      default: true,
      required: false,
      type: Boolean,
    },
  },
};
</script>
